var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExeedingExpectations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.623,
    height: 161.339,
    viewBox: "0 0 150.623 161.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exeeding_Expectations",
    "data-name": "Exeeding Expectations",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19725",
    "data-name": "Path 19725",
    d: "M47.023,71.268H57.779L30.89,39,4,71.268H14.756v29.579H47.023Z",
    transform: "translate(0 62.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19726",
    "data-name": "Path 19726",
    d: "M37.512,108.736H32.134v24.2h26.89V52.268H69.779L42.89,20,16,52.268H26.756V82.061l14.9,17.855a5.378,5.378,0,0,1-4.141,8.82Z",
    transform: "translate(20.268 30.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19727",
    "data-name": "Path 19727",
    d: "M52.492,67.751a2.689,2.689,0,0,0,1.882-.78l20.893-20.92L71.5,42.26,52.492,61.271l-5.727-5.7L43,59.362l7.61,7.61a2.689,2.689,0,0,0,1.882.78Z",
    transform: "translate(65.87 67.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19728",
    "data-name": "Path 19728",
    d: "M81.779,34.268,54.89,2,28,34.268H38.756v27.1l14.9,17.855a5.378,5.378,0,0,1-4.141,8.82H44.134v75.291h26.89v-14.01a29.579,29.579,0,1,0,0-52.65V34.268ZM84.468,98.8a24.2,24.2,0,1,1-24.2,24.2A24.2,24.2,0,0,1,84.468,98.8Z",
    transform: "translate(40.535)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExeedingExpectations);
export default __webpack_public_path__ + "static/media/Exeeding Expectations.42a062a31285523ebdb47d6b749a6971.svg";
export { ForwardRef as ReactComponent };